



















































import { Component, Prop, Vue } from 'nuxt-property-decorator'
import LazyHydrate from 'vue-lazy-hydration'
import ComponentFormButtonIcon from '~/components/form/button-icon.vue'
import ComponentImageGallery from '~/components/images/gallery.vue'
import ComponentProductScripts from '~/components/products/product-scripts.vue'

@Component({
  components: {
    LazyHydrate,
    ComponentFormButtonIcon,
    ComponentImageGallery,
    ComponentProductScripts,
    ComponentPopup: () => import('~/components/popup/popup.vue'),
    ComponentOrderBuyOneClick: () =>
      import('~/components/products/buy-one-click.vue'),
    ComponentReportArrival: () =>
      import('~/components/products/report-arrival.vue'),
  },
})
export default class ComponentProductPageOverlays extends Vue {
  @Prop({ type: Boolean, default: false }) readonly isPhotoPopup!: boolean
  @Prop({ type: Number, default: 0 }) readonly photoStart!: number
  @Prop({ type: Array, default: () => [] }) readonly images!: any[]
  @Prop({ type: Object, required: true }) readonly icons!: Record<
    string,
    string
  >

  @Prop({ type: Boolean, default: false }) readonly isShowSizeChart!: boolean
  @Prop({ default: null }) readonly sizeChart!: any
  @Prop({ type: Boolean, default: false }) readonly isMobileOrTablet!: boolean
  @Prop({ type: Boolean, default: false }) readonly isShowBuyOneClick!: boolean
  @Prop({ type: Boolean, default: false })
  readonly isShowReportArrivalProduct!: boolean

  @Prop({ type: Boolean, default: false }) readonly hasScripts!: boolean
  @Prop({ type: Number, required: true }) readonly id!: number
  @Prop({ type: Array, default: () => [] })
  readonly additionalServicesForBuy!: any[]

  get sizeChartHtml() {
    return this.sizeChart && this.sizeChart.html ? this.sizeChart.html : ''
  }

  get sizeChartModel() {
    return this.isShowSizeChart
  }

  set sizeChartModel(val: boolean) {
    this.$emit('update-size-chart', val)
  }

  get buyOneClickModel() {
    return this.isShowBuyOneClick
  }

  set buyOneClickModel(val: boolean) {
    this.$emit('update-buy-one-click', val)
  }

  get reportArrivalModel() {
    return this.isShowReportArrivalProduct
  }

  set reportArrivalModel(val: boolean) {
    this.$emit('update-report-arrival', val)
  }
}
